/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
function isMobile() {
  if(jQuery("body").css("padding-bottom")==="1px") {
    return true;
  }
  console.log(jQuery("body").css("padding-bottom"));
  return false;
}


window.addEventListener("load",function(){
  if(!isMobile()) {
      jQuery("*[data-bg-image-large!='']").each(function(){
          if(jQuery(this).attr("data-bg-image-large")!==undefined&&jQuery(this).attr("data-bg-image-large")!=="") {
              jQuery(this).css("background-image","url("+jQuery(this).attr("data-bg-image-large")+")");
          }
      });
  }
});